

import React from 'react';

export default () => (
    <iframe src="/HtmlClient/AlertOutbox.html" style={{ width: '100%', height: '100%' }}></iframe>
);